import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // An expired/invalid session sends the user to /login. A failed login attempt (also a 401) must NOT:
    // the login page has to stay mounted to show "email o contraseña incorrectos".
    const isAuthAttempt = /\/auth\/(login|register|confirm-email|resend-confirmation)/.test(error.config?.url || '');
    if (error.response?.status === 401 && !isAuthAttempt && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 